import { $, $$, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode } from 'swiper/modules';

function init() {
  if (!$('[data-au-naked-news]')) return;

  buildSlider();
}

function buildSlider() {
  $$('[data-au-naked-news]').forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Scrollbar, A11y, FreeMode],
      ...sliderConfig,
    });
  });
}

export default { init };
